import React from "react";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import clsx from "clsx";
import { Button, Tooltip } from "@material-ui/core";
import { FaUndo } from "react-icons/fa";

const BulkEditCustomSelect = ({
  id,
  name,
  inputProps,
  disableUnderline,
  value,
  onChange,
  className,
  options,
  errors,
  disabled,
  classes,
  refreshDisabled,
  refreshOnClick,
  title,
  titleClass,
}) => (
  <>
    <label className={classes.globalCreateLabel} htmlFor={title}>
      {title}
    </label>
    <span> :</span>
    <div>
      <Select
        id={id}
        name={name}
        aria-label={title}
        inputProps={{
          id: id,
          "aria-labelledby": id,
          ...inputProps,
        }}
        disableUnderline={disableUnderline}
        disabled={disabled}
        value={value}
        onChange={onChange}
        error={errors && errors[name] ? true : false}
        helperText={(errors && errors[name]) || ""}
        className={className}>
        {options && Array.isArray(options)
          ? options.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))
          : null}
      </Select>
      {!refreshDisabled && (
        <Tooltip title={"Reset to default value"}>
          <Button
            aria-label={name}
            id={name}
            name={name}
            disabled={refreshDisabled}
            onClick={refreshOnClick}
            className={classes.resetButton}>
            <FaUndo style={{ fontSize: "10px" }} />
          </Button>
        </Tooltip>
      )}
    </div>
  </>
);

export default BulkEditCustomSelect;
